import React, { Component, Suspense } from "react";
import moment from "moment";
import { Divider, Modal } from "antd";
import { Row, Col, Card, CardBody } from "reactstrap";
import Chart from "react-google-charts";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import Axios from "axios";

import ContentWrapper from "./../../template/Layout/ContentWrapper";
import VectorMap from "./components/Maps/VectorMap";
import EventsTable from "./components/EventsTable";
import CardsTotals from "./components/CardTotals";
import RSS from "./components/RSS";

import { TableLoader, FullLoader } from "./components/Loader/";
import YearsSelect from "./components/CatYears";
import Loader from "./../../Global/Loader";
import { Services } from "../../../repositories/clients/Services";
import "./styles.scss";
import paises from "./components/Maps/paises.json";
const { confirm } = Modal;

/**
 * @markerColor : the marker points
 * @bgColor : the background
 * @scaleColors : the color of the region in the serie
 * @regionFill : the base region color
 */
const defaultColors = {
  //markerColor: "#020E3A",
  //regionFill: "#0045EF",
  //scaleColors: ["#020e3a","#0045EF"],
  //scaleColors: ["#020e3a"],
  markerColor: "#0045EF",
  bgColor: "transparent",

  scaleColors: ["#0045EF"],

  regionFill: "#020e3a",
};


/*=============================================
=            Dashboard Component Functions    =
=============================================*/
const Map = React.lazy(() => import("./../Components/Maps/map"));
// const latitudPaises = [
//   { latLng: [22.480076, -102.528762], name: 'MX', code: "MX" },
//   { latLng: [40.125132, -103.096824], name: 'USA', code: "USA" },
//   { latLng: [46.595109, 2.870231], name: 'FRA', code: "FRA" }

// ];
/*=============================================
=            Dashboard Component              =
=============================================*/
class Home extends Component {
  constructor(props) {
    super(props);
    this.state = {
      text: "",
      totales: {
        EmbarqueMaritimo: 0,
        EmbarqueAereo: 0,
        EmbarqueTerrestre: 0,
        ContenedorActivo: 0,
      },
      flat: false,
      tendenciaData: [],
      maxTendencia: 0,
      map: (
        <Suspense fallback={<div>Loading...</div>}>
          <Map
            polylineData={[]}
            heidIcon={60}
            disableDefaultUI={true}
            style={{ maxHeight: "300px" }}
            maxHeight="250px"
            marker={[]}
            visible={true}
            type={"polylineDrawer"}
            data={[]}
            dataDrawer={""}
            // zoom={3}
          />
        </Suspense>
      ),
      tendenciaOptions: {
        series: {
          lines: {
            show: false,
          },
          points: {
            show: true,
            radius: 4,
          },
          splines: {
            show: true,
            tension: 0.4,
            lineWidth: 1,
            fill: 0.5,
          },
        },
        grid: {
          borderColor: "#eee",
          borderWidth: 1,
          hoverable: true,
          backgroundColor: "#fcfcfc",
        },
        tooltip: true,
        tooltipOpts: {
          content: (label, x, y) => x + " : " + y,
        },
        xaxis: {
          tickColor: "#fcfcfc",
          mode: "categories",
        },
        yaxis: {
          min: 0,
          tickColor: "#eee",
          autoscaleMargin: 0.5,
          tickDecimals: 0,
          tickFormatter: (v) => v,
        },
        shadowSize: 0,
      },
      Attention: [],
      estatusEmbarques: [],
      Map: [],
      loadingTrends: true,
      loadingTotals: true,
      RegionValues: {},
      fullLoader: false,
      markers: [],
      markersValue: [],
    };
  }
  /*=============================================
  =            Get Info Dashboard Function      =
  =============================================*/
  getInfoDashBoard = async () => {
    let { totales, estatusEmbarques, markers, markersValue, RegionValues } =
      this.state;
    //############ INVOCACION COMENTADA ##############
    let data = {
      Entities: this.props.clients ? JSON.stringify(this.props.clients) : "[0]",
      VariableBranch: this.props.variableBranch
        ? JSON.stringify(this.props.variableBranch)
        : null,
    };
    let response = await Axios.post(
      `${Services.DASHBOARD.path}dashboard/total`,
      data,
    );

    if (response.status === 200) {
      totales = this.obtieneTotales(response.data.data);
      estatusEmbarques = this.obtieneEstatusEmbarques(response.data.data);
      await this.obtieneEventosAtencion();
      await this.obtieneTendenciasEmbarques(moment(Date()).format("YYYY"));
      markersValue = response.data.data.regionValues;
      markers = this.obtieneMarkers(
        response.data.data.regionValues,
        response.data.data.Mapdata,
      );
      RegionValues = this.obtieneRegionValues(response.data.data.regionValues);
    }

    this.setState({
      RegionValues,
      estatusEmbarques,
      totales,
      loadingTotals: false,
      loadingTrends: false,
      fullLoader: true,
      markers,
      markersValue,
    });
  };

  obtieneRegionValues = (regionValues) => {
    var arrayValues = [];
    regionValues.forEach((region) => {
      arrayValues[region.PaisId] = region.total;
    });
    return arrayValues;
  };

  obtieneValorMarkers = (regionValues) => {
    var codeValues = [];
    var keys = [];
    regionValues.forEach((element) => {
      if (codeValues.length === 0 || keys.indexOf(element.POD) < 0) {
        codeValues.push({ total: 1, code: element.POD });
        keys.push(element.POD);
      } else {
        var index = codeValues.findIndex((code) => code.code === element.POD);

        codeValues[index].total = codeValues[index].total + 1;
      }
    });

    return codeValues;
  };

  obtieneMarkers = (markersVaues, markers) => {
    var orderedMarker = [];
    markersVaues.forEach((element) => {
      var mark = markers.filter((marker) => marker.PaisId === element.PaisId);
      orderedMarker.push(mark ? mark[0] : null);
    });
    return orderedMarker;
  };

  obtieneEventosAtencion = async () => {
    const allowUsers = ["1", "3", "4"];
    let data = {
      Entities: this.props.clients ? JSON.stringify(this.props.clients) : "[0]",
    };
    //############ INVOCACION COMENTADA ##############
    let getAttention = allowUsers.includes(this.props._rolId)
      ? await Axios.post(`${Services.DASHBOARD.path}dashboard/events`, data)
      : "";
    let Attention = allowUsers.includes(this.props._rolId)
      ? getAttention.data.data
      : [];
    // let getAttention = allowUsers.includes(this.props._rolId) ? dummyInfo.Eventos : '';
    // let Attention = allowUsers.includes(this.props._rolId) ? getAttention : [];

    this.setState({ Attention });
  };

  obtieneTendenciasEmbarques = async (year) => {
    let { tendenciaData, maxTendencia } = this.state;
    let data = {
      Entities: this.props.clients ? JSON.stringify(this.props.clients) : "[0]",
      year,
    };

    let response = await Axios.post(
      `${Services.DASHBOARD.path}dashboard/tembarques`,
      data,
    );

    if (response.status === 200) {
      tendenciaData = [["x", "Embarques"]];
      response.data.data[0].data.forEach((mes) => {
        tendenciaData.push([mes[0], parseInt(mes[1])]);
        if (parseInt(mes[1]) > maxTendencia) {
          maxTendencia = mes.total;
        }
      });
    }
    //############ INVOCACION COMENTADA ##############
    //tendenciaData = dummyInfo.tEmbarques[year]
    this.setState({ tendenciaData, maxTendencia });
  };

  obtieneEstatusEmbarques = (data) => {
    var estatus = [];
    var colorInicial = "#0045F3";
    data.Embarques.forEach((value) => {
      if (
        value.estatus !== "Creado" &&
        value.estatus !== "En tránsito a destino"
      ) {
        estatus.push({
          nombre: value.estatus,
          total: parseInt(value.total),
          color: colorInicial,
          extra: "",
        });
        colorInicial = this.colores(colorInicial);
      }
    });
    let Logistics = [
      [
        "Element",
        "Total",
        { role: "style" },
        {
          sourceColumn: 0,
          role: "annotation",
          type: "string",
          calc: "stringify",
        },
      ],
    ];
    try {
      estatus.forEach((value) => {
        const element = value;
        Logistics.push([
          element.nombre,
          element.total,
          element.color,
          element.extra,
        ]);
      });
      return Logistics;
    } catch (error) {
      return Logistics;
    }
  };

  hex = (c) => {
    var s = "0123456789abcdef";
    var i = parseInt(c);
    if (i === 0 || isNaN(c)) return "00";
    i = Math.round(Math.min(Math.max(0, i), 255));
    return s.charAt((i - (i % 16)) / 16) + s.charAt(i % 16);
  };
  convertToHex = (rgb) => {
    return this.hex(rgb[0]) + this.hex(rgb[1]) + this.hex(rgb[2]);
  };
  trim = (s) => {
    return s.charAt(0) === "#" ? s.substring(1, 7) : s;
  };

  convertToRGB = (hex) => {
    var color = [];
    color[0] = parseInt(this.trim(hex).substring(0, 2), 16);
    color[1] = parseInt(this.trim(hex).substring(2, 4), 16);
    color[2] = parseInt(this.trim(hex).substring(4, 6), 16);
    return color;
  };
  colores = (startHex) => {
    var start =
      this.convertToRGB(startHex); /* The beginning of your gradient */
    var end = this.convertToRGB("#FFFFFF"); /* The end of your gradient */

    var alpha = 0.7; /* Alpha blending amount */
    var c = [];

    // for (var i = 0; i < len; i++) {

    c[0] = start[0] * alpha + (1 - alpha) * end[0];
    c[1] = start[1] * alpha + (1 - alpha) * end[1];
    c[2] =
      start[2] * alpha +
      (1 - alpha) * end[2]; /* Set the background color of this element */
    // console.log("convertToHex", this.convertToHex(c));
    // start = c;
    // }
    return "#" + this.convertToHex(c);
  };

  obtieneTotales = (data) => {
    var EmbarqueMaritimo = data.totales.Maritimos;
    var EmbarqueAereo = data.totales.Aereos;
    var EmbarqueTerrestre = data.totales.Terrestes;
    var ContenedorActivo = data.totales.Contenedores;
    var totales = {};

    totales = {
      ContenedorActivo,
      EmbarqueMaritimo,
      EmbarqueTerrestre,
      EmbarqueAereo,
    };
    return totales;
  };

  /*=============================================
  =            Life Cicle Component             =
  =============================================*/

  componentDidMount = () => {
    this.getInfoDashBoard();
    document.getElementById("body").className = "layout-fixed"; // !changed for nothing
    const viewModal = localStorage.getItem("viewModal");

    if (
      Number(this.props._passwordExpired) < 11 &&
      Number(this.props._passwordExpired) > -1 &&
      viewModal === "true"
    ) {
      this.changePassword();
    }
  };

  onChangeYear = async (year) => {
    let { tendenciaData, maxTendencia } = this.state;
    maxTendencia = 0;
    let data = {
      Entities: this.props.clients ? JSON.stringify(this.props.clients) : "[0]",
      year: year.value,
      VariableBranch: this.props.variableBranch
        ? JSON.stringify(this.props.variableBranch)
        : null,
    };
    try {
      //############ INVOCACION COMENTADA ##############
      let response = await Axios.post(
        `${Services.DASHBOARD.path}dashboard/tembarques`,
        data,
      );
      if (response.status === 200) {
        tendenciaData = [["x", "Embarques"]];

        response.data.data[0].data.forEach((mes) => {
          tendenciaData.push([mes[0], parseInt(mes[1])]);
          if (parseInt(mes[1]) > maxTendencia) {
            maxTendencia = parseInt(mes[1]);
          }
        });
      }
      this.setState({ tendenciaData, maxTendencia });

      // let TrendShipmentByYear = dummyInfo.tEmbarques[year.value]
      //this.setState({ tendenciaData: TrendShipmentByYear });
    } catch (error) {
      console.error(error);
    }
  };

  changePassword = async () => {
    var mensaje = `Su contraseña expira en ${this.props._passwordExpired} días.`;
    confirm({
      title: <hr className="hr-popover"></hr>,
      icon: false,
      cancelText: "No",
      okText: "Si",
      content: (
        <div>
          <div className="col-12" style={{ textAlign: "center" }}>
            <p class="seacargo-pop-icon">
              <em class="fas fa-exclamation-triangle"></em>
            </p>
            <span>{mensaje}</span>
            <br />
            <span>¿Desea cambiarla ahora?</span>
          </div>
        </div>
      ),
      onOk: () => {
        localStorage.setItem("viewModal", false);
        this.props.history.push(`/myprofile/${this.props._user}`);
      },
      onCancel() {
        localStorage.setItem("viewModal", false);
        console.log("Cancel");
      },
    });
  };

  /*=============================================
  =            Render Method                    =
  =============================================*/

  render() {
    const {
      estatusEmbarques,
      totales,
      tendenciaData,
      maxTendencia,
      Attention,
      loadingTrends,
      loadingTotals,
      RegionValues,
      markersValue,
      fullLoader,
    } = this.state;
    return (
      <>
        <>
          <Loader hidden={fullLoader} />
          <ContentWrapper>
            <div className="content-heading">
              <legend className="styleTitleModule">
                <em
                  // onClick={this.moreContact()}
                  className="icon-final_mesa-de-trabajo-1"
                  style={{ color: "#020E3A" }}
                ></em>
                Tablero de Control{" "}
              </legend>
            </div>
            <Row>
              {/* <div className="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-3"> */}
              <CardsTotals
                image={<em className="icono-totales icon-final-03"></em>}
                // img={}
                xl={3}
                md={6}
                sm={6}
                loading={loadingTotals}
                total={totales.EmbarqueMaritimo}
                title={"Embarques Marítimos"}
                totalClass="total-card-label"
                titleClass="title-card-label"
                propertiesIcon={"col-5 d-flex align-items-center bg-maritimo "}
                propertiesTitle={"col-7 bg-maritimo"}
              />
              {/* </div> */}
              {/* <div className="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-3"> */}
              <CardsTotals
                // image={<img src="data:image/svg+xml;base64, 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" height="45" width="45" />}
                image={<em className="icono-totales icon-final-04"></em>}
                xl={3}
                md={6}
                loading={loadingTotals}
                total={totales.EmbarqueAereo}
                title={"Embarques Aéreos"}
                totalClass="total-card-label"
                titleClass="title-card-label"
                propertiesIcon={"col-5 d-flex align-items-center bg-aereo "}
                propertiesTitle={"col-7 bg-aereo "}
              />
              {/* </div> */}
              {/* <div className="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-3"> */}
              <CardsTotals
                image={<em className="icono-totales icon-final-05"></em>}
                xl={3}
                md={6}
                loading={loadingTotals}
                total={totales.EmbarqueTerrestre}
                title={"Embarques Terrestres"}
                totalClass="total-card-label"
                titleClass="title-card-label"
                propertiesIcon={"col-5 d-flex align-items-center bg-terrestre "}
                propertiesTitle={"col-7 bg-terrestre "}
              />
              {/* </div> */}
              {/* <div className="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-3"> */}
              <CardsTotals
                image={<em className="icono-totales icon-final-08"></em>}
                xl={3}
                md={6}
                loading={loadingTotals}
                total={totales.ContenedorActivo}
                totalClass="total-card-label"
                titleClass="title-card-label"
                title={"Contenedores Activos"}
                propertiesIcon={
                  "col-5 d-flex align-items-center bg-contenedores-activos "
                }
                propertiesTitle={"col-7 bg-contenedores-activos "}
              />
              {/* </div> */}
            </Row>
            <Divider
              style={{
                width: "98.7%",
                marginLeft: "-1px",
                minWidth: "98.7%",
                marginBottom: "20px !important",
              }}
              className="seacargo-divider"
            />
            <Row>
              <RSS type="dashboard"></RSS>
            </Row>
            <Divider
              style={{
                marginTop: "20px !important",
                width: "98.7%",
                marginLeft: "-1px",
                minWidth: "98.7%",
              }}
              className="seacargo-divider"
            />

            <Row
            // style={{ marginTop: "30px" }}
            >
              <div className="col-xs-12 col-md-6 .col-lg-6 ">
                <div className="card myCard equalsWidth">
                  <div className="card-header">
                    <div className="card-title"> Embarques por Estatus </div>
                  </div>
                  {/* <div className="card-body" style={{ overflow: "hidden" }}> */}
                  <CardBody style={{ overflow: "hidden" }}>
                    {loadingTrends ? (
                      <FullLoader />
                    ) : (
                      <div>
                        <Chart
                          // style={{ width: '105%', marginTop: "-25px" }}
                          className={"valueTable"}
                          //width={'100'}
                          // height={300}
                          chartType="BarChart"
                          loader={<div>Loading Chart</div>}
                          data={estatusEmbarques}
                          options={{
                            width: "100%",
                            height: "300px",
                            // bar: { groupWidth: '80%' },
                            chartArea: {
                              // leave room for y-axis labels
                              width: "60%",
                              // height: '600px'
                            },
                            tooltip: { isHtml: true },
                            legend: {
                              position: "none",
                            },
                            animation: {
                              startup: true,
                              easing: "linear",
                              duration: 1000,
                            },
                          }}
                          rootProps={{ "data-testid": "6" }}
                        />
                      </div>
                    )}
                  </CardBody>
                  {/* </div> */}
                </div>
              </div>
              <div className="col-xs-12 col-md-6 .col-lg-6 ">
                <div className="card myCard equalsWidth">
                  <div className="card-header">
                    <Col md={12}>
                      <Row>
                        <Col xs={8} md={8} lg={8}>
                          <div className="card-title">
                            {" "}
                            Tendencia de Embarques{" "}
                          </div>
                        </Col>
                        <Col xs={4} md={4} lg={4}>
                          <YearsSelect onChangeYear={this.onChangeYear} />
                        </Col>
                      </Row>
                    </Col>
                  </div>
                  {/* <div className="card-body" style={{ overflow: "hidden" }}> */}
                  <CardBody style={{ overflow: "hidden" }}>
                    {loadingTrends ? (
                      <FullLoader />
                    ) : (
                      // <FlotChart data={tendenciaData} heightDash={height}  options={tendenciaOptions} />
                      <div>
                        <Chart
                          // style={{ width: '110%', marginTop: "-25px", marginLeft: "-35px" }}
                          className={"valueTable"}
                          chartType="LineChart"
                          loader={<div>Loading Chart</div>}
                          data={tendenciaData}
                          options={{
                            width: "100%",
                            height: "300px",
                            curveType: "function",
                            legend: {
                              position: "none",
                            },
                            tooltip: { isHtml: true },
                            vAxis: {
                              minValue: 0,
                              viewWindow: { min: 0, max: maxTendencia + 1 },
                            },

                            pointSize: 5,
                            series: {
                              0: {
                                color: "#002297",

                                lineWidth: 2,
                              },
                            },
                            // backgroundColor: {
                            //   fill: '#F4F4F4',
                            //   opacity: 100
                            // }
                          }}
                          rootProps={{ "data-testid": "1" }}
                        />
                      </div>
                    )}
                  </CardBody>
                </div>
              </div>
            </Row>
            <Row style={{ marginTop: "30px" }}>
              <Col xl={6}>
                <Card className="myCard equalsWidth">
                  <div className="card-header">
                    <div className="card-title">
                      {" "}
                      Eventos que Requieren Atención{" "}
                    </div>
                  </div>
                  <CardBody>
                    {loadingTrends ? (
                      <TableLoader />
                    ) : (
                      <EventsTable data={Attention} />
                    )}
                  </CardBody>
                </Card>
              </Col>
              <Col xl={6}>
                <Card className="myCard equalsWidth">
                  <div className="card-header">
                    <div className="card-title">
                      {" "}
                      Embarques por País de Origen{" "}
                    </div>
                  </div>
                  <CardBody style={{ overflow: "hidden" }}>
                    {loadingTrends ? (
                      <TableLoader />
                    ) : (
                      // this.state.map
                      <VectorMap
                        options={{
                          map: "world_mill_en",
                          markersSelectable: true,
                          backgroundColor: defaultColors.bgColor,
                          zoomMin: 1,
                          zoomMax: 8,
                          zoomOnScroll: false,
                          regionStyle: {
                            initial: {
                              fill: defaultColors.regionFill,
                              "fill-opacity": 1,
                              stroke: "none",
                              "stroke-width": 1.5,
                              "stroke-opacity": 1,
                            },
                            hover: {
                              //fill: '#020E3A',
                              fillOpacity: 0.8,
                            },
                            selected: {
                              fill: "#020E3A",
                            },
                            selectedHover: {
                              fill: "#020E3A",
                              fillOpacity: 0.8,
                            },
                          },
                          focusOn: {
                            x: 0.4,
                            y: 0.6,
                            scale: 1,
                          },
                          markerStyle: {
                            initial: {
                              fill: defaultColors.markerColor,
                              fillOpacity: 0.8,
                              stroke: defaultColors.markerColor,
                            },
                          },
                          onRegionLabelShow: (e, el, code) => {
                            paises.countries.forEach((pais) => {
                              if (pais.code === code) {
                                el.html(pais.name_es);
                              }
                            });
                            markersValue.forEach((mark) => {
                              if (mark.PaisId === code) {
                                el.html(
                                  el.html() + ": " + mark.total + " Embarques",
                                );
                              }
                            });
                          },
                          // onRegionOver: (e, code) => {
                          //   e.preventDefault();
                          // },
                          // // onMarkerSelected: this.handleMarkerClick,
                          // onMarkerLabelShow: (e, el, code) => {
                          //   e.preventDefault();
                          // },
                        }}
                        series={{
                          regions: [
                            {
                              values: RegionValues,
                              scale: defaultColors.scaleColors,
                              normalizeFunction: "polynomial",
                            },
                          ],
                        }}
                        // markers={markers}
                        markers={[]}
                      />
                    )}
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </ContentWrapper>
        </>
      </>
    );
  }
}
const mapStateToProps = (state) => ({
  clients: state.header.clients,
  variableBranch: state.header.variableBranch,
});
const mapDispatchToProps = () => ({});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Home));

//export default connect(mapStateToProps, mapDispatchToProps)(Home);
